import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';

import { BoldFieldLabel, InputTitle, InputWrapper } from './css';
import Note from '../../note';
import formFieldOperationOptions from '../../utils/formFieldOperationOptions';
import { fieldEmergencyPassword, typePassword } from '../../utils/constant';
import FieldLocationInput from './fieldLocationInput';
import FieldGuide from './common/fieldGuide';

const FieldInput = ({ data }) => {
  const {
    ref,
    name,
    type,
    label,
    value,
    title,
    required,
    placeholder,
    maxLength,
    minLength,
    onChange,
    readonly,
    tooltip,
    note,
    disabled,
    horizontalFormat,
    labelColor,
    noteAppearsBelowField,
    onBlur,
    isShowNoteBackground,
    isWarningMessage,
    isItalicNote
  } = data;
  const renderNotes = () => {
    return (
      note &&
      note.content && (
        <Note
          type="richText"
          options={formFieldOperationOptions(value)}
          data={note}
          isItalicNote={isItalicNote}
          isWarningMessage={isWarningMessage}
          isShowNoteBackground={isShowNoteBackground}
        />
      )
    );
  };
  const onInputBlur = (e, refV) => {
    try {
      onBlur(e, refV);
    } catch (err) {}
  };
  const onInputChange = e => {
    if (type === 'Number') {
      const {
        target: { value: currentValue }
      } = e;
      if (parseInt(currentValue, 10) < 0) {
        e.target.value = 0;
      }
    }
    onChange(e);
  };

  const onKeyDown = e => {
    if (type === 'Number') {
      ['e', 'E'].includes(e.key) && e.preventDefault();
    }
    onChange(e);
  };
  // if field type is Number then it'll prevent vlaue change when scrolled within/over it
  const handleScroll = e => {
    if (type === 'Number') {
      e.currentTarget.blur();
      e.preventDefault();
    }
  };

  return (
    <>
      {title && <InputTitle>{title}</InputTitle>}
      <InputWrapper isHorizontal={horizontalFormat}>
        <div style={{ flex: 1, color: labelColor, textAlign: horizontalFormat ? 'right' : 'left', display: 'inline-flex', alignItems: 'center' }}>
          <BoldFieldLabel labelColor={labelColor}>
            <Typography block heading="h4" variant={{ size: 'h4', bold: true }}>
              {label}
              {required && `*`}
            </Typography>
          </BoldFieldLabel>
          {tooltip && (
            <span style={{ marginLeft: '0.5rem' }}>
              <FieldGuide tooltip={tooltip} />
            </span>
          )}
        </div>
        {type !== 'Address' && note && note.content && (
          <Note
            type="richText"
            data={note}
            isShowNoteBackground={isShowNoteBackground}
            isItalicNote={isItalicNote}
          />
        )}
        <div style={{ position: 'relative', flex: 3 }}>
          {type === 'Address' || type === 'AddressDetails' ? (
            <FieldLocationInput data={data} />
          ) : (
            <input
              ref={ref}
              id={name}
              name={name}
              type={name === fieldEmergencyPassword ? typePassword : type}
              value={value}
              maxLength={maxLength}
              minLength={minLength}
              readOnly={readonly}
              placeholder={placeholder}
              disabled={disabled}
              className="frg-input-field color-light"
              style={{ width: '100%' }}
              onChange={(e, ref) => onInputChange(e, ref)}
              onBlur={(e, ref) => onInputBlur(e, ref)}
              onKeyDown={e => onKeyDown(e)}
              onWheel={e => handleScroll(e)}
            />
          )}
        </div>
      </InputWrapper>
    </>
  );
};

FieldInput.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    title: PropTypes.string,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    horizontalFormat: PropTypes.bool,
    labelColor: PropTypes.string,
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    noteAppearsBelowField: PropTypes.bool.isRequired
  }).isRequired
};

export default FieldInput;
